import React, { Component, Fragment } from 'react'
import clone from 'lodash/clone'
import setQuery from 'set-query-string'
import { parseQuery, setGuestParams } from '../../utils'
import API from '../../api'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import each from 'lodash/each'
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl'
import DateFormat from '../helpers/DateFormat'
import Pagination from 'react-js-pagination'
import ShopSlider from '../search/ShopSlider'
import ReviewLabel from '../helpers/ReviewLabel'
import SellingPropositionDr from './SellingPropositionDr'
import OperatorSwitchDr from './OperatorSwitchDr'

import { toast } from 'react-toastify'
import { mealPlanIcon } from '../resort/ResortPricingRow'
import PlaceholderResort from './PlaceholderResort'
import PriceVariants from './PriceVariants'
import EcoLabels from '../resort/EcoLabels'
import store from 'store2'

const PAGE_SIZE = 10

const msg = defineMessages({
  customizeDives: {
    id: 'tooltip.customize_dives',
    defaultMessage: 'You can customize the number of dives for each diver during the checkout process. The package price will be adjusted dynamically',
  },
  warningDatesNotExact: {
    id: 'warningDatesNotExact',
    defaultMessage: 'Dates are not an exact match with your search criteria. Only specific start dates are possible. Go to the resort page and open the date picker to see which ones.',
  },
  warningDurationNotExact: {
    id: 'warningDurationNotExact',
    defaultMessage: 'Duration is not an exact match with your search criteria. Only specific durations are possible. Go to the resort page and open the date picker to see which ones.',
  },
  warningDatesAndDurationNotExact: {
    id: 'warningDatesAndDurationNotExact',
    defaultMessage: 'Dates & duration are not an exact match with your search criteria. Only specific start dates & durations are possible. Go to the resort page and open the date picker to see which ones.',
  },
})

class ResortComponent extends Component {
  constructor(props) {
    super(props)

    const query = parseQuery()

    this.state = {
      loading: true,
      page: query && query.page ? +query.page : 1,
      shops: [],
      pageCount: 0,
    }

    this.tripContainerRef = React.createRef()
  }

  controller
  signal

  componentDidMount() {
    this.getTrips()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(prevProps.selectedParams) !== JSON.stringify(this.props.selectedParams) ||
      prevProps.getNewData !== this.props.getNewData
    ) {
      this.setState({
        page: 1,
        loading: true,
      }, this.getTrips)
    }
  }

  getTrips = () => {
    const { model, pk } = this.props

    let highlightSlug = ''

    if(window.highlightedShopSlug && window.highlightedShopSlug !== '') {
      highlightSlug = window.highlightedShopSlug + '/'
    }

    if(this.controller !== undefined) {
      // Cancel the previous request
      this.controller.abort()
    }

    if('AbortController' in window) {
      this.controller = new window.AbortController()
      this.signal = this.controller.signal
    }

    return API(`search/${model.toLowerCase()}/${pk}/resorts/${highlightSlug}`, this.signal).get({
      page: this.state.page,
      page_size: PAGE_SIZE,
      ...this.props.selectedParams,
    }).then((data) => {
      this.props.setNumberOfItems(data.count, 'numberOfBoats')
      each(data.results, shop => {
        if(shop.dateStart) {
          shop.dateEnd = moment(shop.dateStart).add(shop.nights, 'd').format('YYYY-MM-DD')
          shop = this.packageWarningMsg(shop)
        }
      })
      this.setState({
        shops: data.results,
        loading: false,
        numberOfTrips: data.count,
      }, () => {
        ReactTooltip.rebuild()
      })
    }).catch((error) => {
      if(window.DOMException && error.code === window.DOMException.ABORT_ERR) {
        console.warn('Request canceled.')
      } else {
        this.setState({
          loading: false,
          numberOfTrips: 0,
          shops: [],
        })
        toast.error(<FormattedMessage id='went_wrong' defaultMessage='Something went wrong' />, {
          position: toast.POSITION.TOP_CENTER,
        })
      }
    })
  }

  onPageChange = (page) => {
    window.scrollTo(0, this.tripContainerRef.current.offsetTop)
    setQuery({ page })
    this.setState({
      page,
      loading: true,
    }, this.getTrips)
  }

  queriesForWidget(url) {
    if(!this.props.isWidget) {
      setGuestParams(this.props.selectedParams, this.props.totalGuests)
      return url
    }

    const params = parseQuery()

    let query = `${url.indexOf('?') === -1 ? '?' : '&'}utm_campaign=WW-ALL-ALL-DI-Affiliates&utm_medium=widget&utm_content=${params.popup ? 'search_modal' : 'search_iframe'}&`

    if(params.aid) {
      query += `utm_source=affiliate_${params.aid}&aid=${params.aid}&`

      if(params.cid) {
        query += `cid=${params.cid}`
      }
    }

    return url + query
  }

  getDCLocationType(type) {
    switch (+type) {
      case 10:
        return <FormattedMessage id='onsite' defaultMessage='Onsite' />
      case 20:
        return <FormattedMessage id='walking_distance' defaultMessage='Walking distance' />
      case 30:
        return <FormattedMessage id='offsite_free_pickup' defaultMessage='Offsite (Free pickup)' />
      case 40:
        return <FormattedMessage id='offsite_paid_pickup' defaultMessage='Offsite (Paid pickup)' />
      default:
        return ''
    }
  }

  packageWarningMsg = (shop) => {
    const { selectedParams, intl } = this.props
    const resortDateStart = moment(shop.dateStart).utc().format('YYYY-MM-DD')
    // Date start are the same but duration is not equal
    if(resortDateStart !== selectedParams.dateStart && shop.nights === +selectedParams.nights) {
      shop.errorMsg = intl.formatMessage(msg.warningDatesNotExact)
      // Date start is not the same but duration is equal
    } else if(shop.nights !== +selectedParams.nights && resortDateStart === selectedParams.dateStart) {
      shop.errorMsg = intl.formatMessage(msg.warningDurationNotExact)
      // Date start and duration not equal
    } else if(shop.nights !== +selectedParams.nights && resortDateStart !== selectedParams.dateStart) {
      shop.errorMsg = intl.formatMessage(msg.warningDatesAndDurationNotExact)
    }
    if(shop.errorMsg) {
      if(!shop.unmutableURL) {
        shop.unmutableURL = clone(shop.url)
      }

      shop.url = shop.unmutableURL + '?date_from=' + resortDateStart + '&duration=' + shop.nights
    }

    return shop
  }

  jumpToEmptyInput = (e) => {
    e.stopPropagation()
    if(!this.props.totalGuests) {
      setTimeout(function() {
        document.querySelector('.rooms-and-guest-selector').click()
      })
    } else if(!this.props.selectedParams.nights) {
      document.getElementById('datepicker').click()
    }
  }

  render() {
    const { intl, selectedParams, totalGuests, isAllParamsSelected } = this.props

    if(this.state.loading) {
      return (
        <Fragment>
          {
            [...new Array(10)].map((_, i) => {
              return (<PlaceholderResort key={i} />)
            })
          }
        </Fragment>
      )
    }
    return (
      <div ref={this.tripContainerRef} className='results'>
        {
          this.state.shops && this.state.shops.map((shop, index) => {
            return (
              <Fragment key={shop.shopId}>
                <div className={`dive-resort search-page-item-card ${shop.isHighlighted ? 'highlighted' : ''}`}>
                  <div className='dive-resort-content'>
                    <div className='photo-slider'>
                      <ShopSlider slug={shop.slug} shopUrl={this.queriesForWidget(shop.url)} background={shop.background.GridSearchResultDesktop} />
                      <span className={`heart ${shop.isWishlist ? 'active' : ''}`}
                        data-shop-slug={shop.slug}
                        data-type='Shop'
                        data-in-wishlist={shop.isWishlist}
                        data-wishlist-id={shop.isWishlist} />
                    </div>
                    <div className='resort-info' onClick={(e) => {
                      e.stopPropagation()
                      window.open(this.queriesForWidget(shop.url), '_blank')
                    }}>
                      <div className='result-head'>
                        <p className='resort-title'>
                          { shop.title }
                        </p>
                        <ReviewLabel
                          scubaTribe={shop.scubaTribe}
                          shopKind={shop.kind}
                          padiRating={shop.numberOfReviews}
                          tripAdvisor={shop.tripAdvisor}
                          urlParams={{ location: shop.referenceLocationCountrySlug || shop.countrySlug, slug: shop.slug || shop.shopSlug }}
                        />
                      </div>
                      <div className='dr-row'>
                        <div className='half amenities-container'>
                          <div className={`amenities 
                            ${shop.numberOfReviews > 2 || shop.tripAdvisor ? 'have-rating' : ''}
                            ${shop.minimalStay > selectedParams.nights ? 'minimal-stay' : ''}
                          `}>
                            { isAllParamsSelected && shop.errorMsg ? (
                              <p className='dates'>
                                <i className='tooltip-wrapper-block font-icons icon-warning' data-for='global' data-tip={shop.errorMsg} />
                                <DateFormat date={shop.dateStart} /> - <DateFormat date={shop.dateEnd} />
                              </p>
                            ) : '' }
                            <p>
                              <i className='font-icons location-icon' />
                              { shop.locationTitle }
                            </p>
                            <p>
                              <i className={mealPlanIcon(shop.mealPlan)} />
                              <span>{ shop.mealPlanTitle || <FormattedMessage id='room_only' defaultMessage='Room only' /> }</span>
                            </p>
                            { shop.stars ? (
                              <p>
                                <i className='font-icons icon-star-outline' />
                                <FormattedMessage id='star_hotel'
                                  values={{ stars: shop.stars }}
                                  defaultMessage='{ stars } star hotel' />
                              </p>
                            ) : '' }
                          </div>
                          <div className='dc-info amenities' onClick={(e) => {
                            e.stopPropagation()
                          }}>
                            <span className='dc-title'>{ shop.diveCenterTitle }</span>
                            <p>
                              <i className='font-icons icon-padi-small' />
                              { shop.diveCenterHasFiveStar ? (
                                <FormattedMessage id='5_star_dc' defaultMessage='5 star dive center' />
                              ) : (<FormattedMessage id='dive_center' defaultMessage='dive center' />)
                              }
                            </p>
                            <p>
                              <i className='font-icons location-icon' />
                              { this.getDCLocationType(shop.resortLocationType) }
                            </p>
                            {
                              selectedParams.divers > 0 ? (
                                <p className='dives'>
                                  {
                                    shop.divesInPackageKind !== 30 && shop.numberOfDives ? (
                                      <Fragment>
                                        <i className='font-icons dive-center-icon' />
                                        <FormattedMessage
                                          id='incl_number_of_dive_dive_type'
                                          values={{
                                            numberOfDives: shop.numberOfDives / (selectedParams.divers || 1),
                                            diveType: shop.diveTypeTitle,
                                          }}
                                          defaultMessage='Incl. { numberOfDives } { diveType } { numberOfDives, plural, one {dive} other {dives}} per diver' />
                                        { shop.divesInPackageKind === 20 ? (
                                          <Fragment>
                                            <br />
                                            +<FormattedMessage id='unlimited_shore_dives' defaultMessage='Unlimited shore dives' />
                                          </Fragment>
                                        ) : '' }
                                      </Fragment>
                                    ) : ''
                                  }
                                  {
                                    shop.divesInPackageKind === 30 ? (
                                      <Fragment>
                                        <i className='font-icons dive-center-icon' />
                                        <FormattedMessage id='unlimited_shore_dives' defaultMessage='Unlimited shore dives' />
                                      </Fragment>
                                    ) : ''
                                  }
                                  {
                                    !shop.availablePackageKinds ? (
                                      <span className='tooltip-wrapper-block pill green' data-for='global' data-tip={intl.formatMessage(msg.customizeDives)}>
                                        <FormattedMessage id='fully_flexible' defaultMessage='Fully flexible' />
                                        <i className='font-icons info-icon' />
                                      </span>
                                    ) : ''
                                  }
                                </p>
                              ) : ''
                            }
                            {
                              selectedParams.students > 0 ? (
                                <p className='dives'>
                                  <i className='font-icons dive-center-icon' />
                                  <FormattedMessage id='incl_open_water' defaultMessage='Incl. PADI Open Water Course' />
                                </p>
                              ) : ''
                            }
                            { shop.diveCenterEcoLabels &&
                              <div className='eco-labels'>
                                <EcoLabels labelsList={shop.diveCenterEcoLabels} />
                              </div>
                            }
                          </div>
                        </div>
                        <div className='half'>
                          <PriceVariants shop={shop} selectedParams={selectedParams} totalGuests={totalGuests} isAllParamsSelected={isAllParamsSelected} />
                          { isAllParamsSelected
                            ? (<a className='btn-red' target='_blank'>
                              <FormattedMessage id='view_packages' defaultMessage='View packages' />
                            </a>) : (
                              <a className='btn-red' onClick={this.jumpToEmptyInput}>
                                <FormattedMessage id='view_prices' defaultMessage='View prices' />
                              </a>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                { !this.props.parentElement && (index === 2 || (this.state.shops.length < 3 && this.state.shops.length === index + 1)) ? <SellingPropositionDr /> : ''}
              </Fragment>)
          })
        }
        {
          !this.state.loading ? (<OperatorSwitchDr {...this.props.liveaboardDetails} />) : ''
        }
        { this.state.numberOfTrips > 10
          ? (<div className='pagination-wrap'>
            <Pagination
              activePage={this.state.page}
              innerClass='custom-pagination'
              itemsCountPerPage={PAGE_SIZE}
              itemClassPrev='prev'
              itemClassNext='next'
              prevPageText=''
              nextPageText=''
              itemClassFirst='hidden'
              itemClassLast='hidden'
              totalItemsCount={this.state.numberOfTrips}
              pageRangeDisplayed={5}
              onChange={this.onPageChange}
            />
          </div>) : ''
        }
      </div>
    )
  }
}

ResortComponent.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ResortComponent)
